(function() {
  'use strict';

  // Wait for Bold's options.js to finish its cart re-render, then fix $NaN prices
  function fixNaNPrices() {
    var cartContainer = document.querySelector('#CartDrawer, .ajaxcart__inner, [id*="CartDrawer"], .drawer__scrollable');
    if (!cartContainer) return;

    // Find any element showing $NaN and replace with the correct value
    cartContainer.querySelectorAll('.ajaxcart__price, .cart__price').forEach(function(el) {
      if (el.textContent.includes('NaN')) {
        // Find the closest product row and get the correct price from data attributes
        var row = el.closest('.ajaxcart__product, .ajaxcart__row');
        if (!row) return;

        // Get the item key from the quantity input in this row
        var qtyInput = row.querySelector('input[data-id]');
        if (!qtyInput) return;
        var itemKey = qtyInput.getAttribute('data-id');

        // Look up the correct price from cart.js
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var item = cart.items.find(function(i) { return i.key === itemKey; });
            if (!item) return;

            var totalDiscount = item.total_discount || 0;
            var qty = item.quantity || 1;
            var discountedPrice = item.price - (totalDiscount / qty);

            // Format using Shopify's money format
            var formatted = formatMoney(discountedPrice, window.theme && window.theme.settings && window.theme.settings.moneyFormat || '${{amount}}');

            el.textContent = formatted;
          });
      }
    });
  }

  // Simple money formatter matching Shopify's format
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  // Watch for Bold's re-render using MutationObserver on the body
  var observer = new MutationObserver(function(mutations) {
    var needsFix = false;
    mutations.forEach(function(m) {
      if (m.addedNodes.length) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList && (node.classList.contains('ajaxcart__product') || node.classList.contains('ajaxcart__row')) ||
            node.querySelector && node.querySelector('.ajaxcart__price')
          )) {
            needsFix = true;
          }
        });
      }
    });
    if (needsFix) {
      setTimeout(fixNaNPrices, 50); // slight delay to let Bold finish
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
